import { createStyles, makeStyles } from '@material-ui/core'
import React, { useState } from 'react'
import {
  sanitizeFetchType,
  useMutation,
  useNotify,
  useRefresh,
  useShowContext,
} from 'react-admin'
import { Authority } from '../../../../../core/auth/Authority'
import { CameraServerDto } from '../../../../../core/dto/device/camera/camera-servers/camera-server.dto'
import { ResourceName } from '../../../../../core/ResourceName'
import { ConfirmDialog } from '../../../../common/ConfirmDialog'
import Button from '../../../../common/customized-mui-components/Button'
import { useHasAuthority } from '../../../../hooks/useHasAuthority'

const useStyles = makeStyles(() =>
  createStyles({
    button: {
      margin: '2px',
    },
  }),
)

export const CameraServerRemoveCredentialsButton = () => {
  const { record: cameraServer, loading } = useShowContext<CameraServerDto>()
  const classes = useStyles()
  const [removeCredentialsDialogOpen, setRemoveCredentialsDialogOpen] =
    useState(false)
  const hasAuthority = useHasAuthority()
  const [mutate, { loading: mutationLoading }] = useMutation()
  const refresh = useRefresh()
  const notify = useNotify()

  const handleRemoveCredentials = async () => {
    setRemoveCredentialsDialogOpen(false)
    await mutate(
      {
        type: sanitizeFetchType('removeCredentials'),
        resource: ResourceName.CAMERA_SERVERS,
        payload: {
          cameraServerId: cameraServer?.id,
        },
      },
      {
        returnPromise: true,
        onFailure: (err) => notify(err?.message, 'error'),
      },
    )
    refresh()
  }

  const handleRemoveCredentialsDialog = () => {
    setRemoveCredentialsDialogOpen(true)
  }

  return (
    <>
      <ConfirmDialog
        open={removeCredentialsDialogOpen}
        confirm={handleRemoveCredentials}
        source="setCredentials"
        cancel={() => setRemoveCredentialsDialogOpen(false)}
        action="remove"
        resource={ResourceName.CAMERA_SERVERS}
      />
      <Button
        variant="contained"
        onClick={handleRemoveCredentialsDialog}
        color="primary"
        className={classes.button}
        label="resources.camera-servers.actions.removeCredentials"
        useSmallVersionBreakpoint={false}
        disabled={
          !hasAuthority(Authority.CAMERA_SERVERS_MANAGE_CREDENTIALS_BUTTON) ||
          loading ||
          mutationLoading
        }
      />
    </>
  )
}
